// Keep the following in sync with packages/rum/src/entries/main.ts
import { defineGlobal, getGlobalObject } from '@datadog/browser-core';
import { makeRumPublicApi, startRum } from '@datadog/browser-rum-core';
import { makeStubRecorderApi } from '../boot/stubRecorderApi';
export { DefaultPrivacyLevel } from '@datadog/browser-core';
export var datadogRum = makeRumPublicApi(startRum, makeStubRecorderApi());
defineGlobal(getGlobalObject(), 'DD_RUM', datadogRum);
//# sourceMappingURL=main.js.map